import React, { useEffect, useState } from 'react';

const Status = ({ text }) => {
  const [statusClass, setStatusClass] = useState('');

  useEffect(() => {
    // Définir la classe CSS en fonction du statut
    switch (text) {
      case 'Activé':
      case 'Publié':
        setStatusClass('status-success');
        break;
        case 'E':
          setStatusClass('status-confirmed');
          break;
      case 'En attente':
        setStatusClass('status-pending');
        break;
      case 'Désactivé':
        setStatusClass('status-error');
        break;
      default:
        setStatusClass('status-unknown');
        break;
    }
  }, [text]);

  return (
    <div className={`status ${statusClass}`}>
      <div className='min-w-[10px] h-[10px] rounded-full inline-block mr-1'></div>
      {text}
    </div>
  );
}

export default Status;
